
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ name: "CPlaceholder" })
export default class CPlaceholder extends Vue {
  @Prop({ required: true }) public icon!: string;
  @Prop({ required: false, default: null }) public description!: string | null;
}
